export const QUERY_ENGAGEMENT = "QUERY_ENGAGEMENT";
export const QUERY_ENGAGEMENT_LIST = "QUERY_ENGAGEMENT_LIST";
export const QUERY_ENGAGEMENT_LIST_ALL = "QUERY_ENGAGEMENT_LIST_ALL";
export const QUERY_ENGAGEMENT_LIST_SIZE = "QUERY_ENGAGEMENT_LIST_SIZE";
